import { DbTable } from '../db-table';
import { HttpClient } from '@angular/common/http';
import { Product, AssociatedProduct } from '../../../../core/_shared/models/product';
import { PaymentMethod } from "../../../../core/_shared/models/PaymentMethod";
import { FinancialTransaction } from "../../../../core/_shared/models/FinancialTransaction";
import { PaymentResult } from "../../../../core/_shared/models/PaymentResult";
import { Scheme } from "../../../../core/_shared/models/Scheme";
import {  httpOptionsDefault } from '../../../../core/_shared/constants';
import { map, catchError } from 'rxjs/operators';
import { CreditCardModel, PersonalDataModel } from '../../../_shared/models/credit-card.model';
import { WebApiService } from '../../WebApiService';
export class DbProducts extends DbTable<Product> {
    constructor(private http: HttpClient,private webApi:WebApiService) {
        super(http,webApi,"products");
    }
}




export class DbPaymentMethods extends DbTable<PaymentMethod> {

    constructor(private http: HttpClient,private webApi:WebApiService) {
        super(http,webApi, "paymentMethods");
    }

  getToCustomerList(): Promise<PaymentMethod[]> {

        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/toCustomers`)
            .pipe(
                map((result:PaymentMethod[]) => {
              
                    return result;

                })).toPromise();
  }
}


export class DbFinancialTransactions extends DbTable<FinancialTransaction> {

    constructor(public _http: HttpClient,public _webApi:WebApiService) {

        super(_http,_webApi, `financialTransactions`);

    }

}



